import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // Sem isso, staleTime default é 0 — TODO remount de componente (reabrir
  // um dialog, trocar de aba do menu e voltar) e todo refetchOnWindowFocus
  // (alt-tab, trocar de app no celular e voltar) disparava um refetch na
  // hora, e a tela piscava com o "flash" de dado antigo→novo mesmo quando
  // nada mudou de verdade no servidor (sintoma relatado 2026-08-28: app
  // "piscando"/lento, principalmente em telas como Histórico). Hooks que
  // realmente precisam de dado quase em tempo real (mapa, posições,
  // alertas) já declaram seu próprio `refetchInterval` explícito — esses
  // continuam intocados, refetchOnWindowFocus:false só remove o refetch
  // REDUNDANTE de dado que não tem polling próprio.
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
